import React, { FC, ReactNode } from 'react'

import s from './index.scss'
import WixStudioLogo from './logo.svg'

type EnterpriseLayoutProps = {
  children?: ReactNode
}

export const EnterpriseLayout: FC<EnterpriseLayoutProps> = ({ children }) => {
  return (
    <div className={s.EnterpriseLayout}>
      <div className={s.EnterpriseLayout__header}>
        <WixStudioLogo height={24} width={100} />
      </div>
      <div className={s.EnterpriseLayout__content}>{children}</div>
    </div>
  )
}
